var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { computed, ref } from "vue";
import { withPrefix } from "@/utils/redirect";
import { getRedirectOnImportPath } from "../redirectPath";
import LoadingSpan from "@/components/LoadingSpan.vue";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FromFileOrUrl',
    setup(__props) {
        const loading = ref(false);
        const sourceURL = ref(null);
        const sourceFile = ref(null);
        const errorMessage = ref(null);
        const acceptedWorkflowFormats = ".ga, .yml";
        const isImportDisabled = computed(() => {
            return !sourceFile.value && !sourceURL.value;
        });
        const importTooltip = computed(() => {
            return isImportDisabled.value
                ? "You must provide a workflow archive URL or file."
                : sourceURL.value
                    ? "Import workflow from URL"
                    : "Import workflow from File";
        });
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        function autoAppendJson(urlString) {
            const sharedWorkflowRegex = /^(https?:\/\/[\S]+\/u\/[\S]+\/w\/[^\s/]+)\/?$/;
            const matches = urlString.match(sharedWorkflowRegex);
            const bareUrl = matches === null || matches === void 0 ? void 0 : matches[1];
            if (bareUrl) {
                return `${bareUrl}/json`;
            }
            else {
                return urlString;
            }
        }
        const router = useRouter();
        function submit(ev) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                ev.preventDefault();
                const formData = new FormData();
                if (sourceFile.value) {
                    formData.append("archive_file", sourceFile.value);
                }
                if (sourceURL.value) {
                    const url = autoAppendJson(sourceURL.value);
                    formData.append("archive_source", url);
                }
                loading.value = true;
                try {
                    const response = yield axios.post(withPrefix("/api/workflows"), formData);
                    const path = getRedirectOnImportPath(response.data);
                    router.push(path);
                }
                catch (error) {
                    const message = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.data.err_msg);
                    errorMessage.value = message || "Import failed for an unknown reason.";
                }
                finally {
                    loading.value = false;
                }
            });
        }
        return { __sfc: true, loading, sourceURL, sourceFile, errorMessage, acceptedWorkflowFormats, isImportDisabled, importTooltip, hasErrorMessage, autoAppendJson, router, submit, LoadingSpan };
    }
});
